/**
 * KREMİ FAVORİLER — web istemcisi (Commerce App, karar 2026-08-31).
 *
 * Veri: App Proxy `/apps/kremi/wishlist` → mobile-api (mobil uygulamayla AYNI
 * kayıt; müşteri telefonda eklediğini burada görür).
 *   GET  /                → { items: [{ productGid, handle?, addedAt }] }
 *   POST /items           { productGid, handle? }  → { items }
 *   POST /items/remove    { productGid }           → { items }
 *
 * FAIL-SAFE TASARIM: App Proxy kurulu değilse (kurulum öncesi 404) ya da ağ
 * düşerse HİÇBİR kalp butonu görünmez — canlı sitede kırık/çalışmayan buton
 * bırakmaz. Butonlar `hidden` doğar; yalnız sağlıklı ilk yanıttan sonra açılır.
 *
 * Misafir (giriş yapmamış) durumu: proxy 401 döner. Bu "bozuk" değil, "giriş
 * gerekli" demektir → butonlar görünür ama tıklayınca giriş sayfasına gider.
 */
(function () {
  var BASE = (window.KREMI_WISHLIST_BASE || '/apps/kremi') + '/wishlist';
  // HIZ-HATA T4/H3 (2026-10-01): sabit '/account/login' dil önekini bilmiyordu (EN
  // vitrinde TR giriş sayfasına gidiyordu). window.KREMI_LOGIN_URL (layout/theme.liquid,
  // routes.account_login_url) zaten doğru dil+bölge sorgusunu taşıyor; '?' içerebildiği
  // için return_url'i AYRAÇI KOŞULLU ekliyoruz (aksi halde ikinci '?' region_country'nin
  // değerine gömülüyordu — T1/H3).
  var LOGIN_URL = window.KREMI_LOGIN_URL || '/account/login';

  function loginUrlWithReturn(path) {
    var sep = LOGIN_URL.indexOf('?') === -1 ? '?' : '&';
    return LOGIN_URL + sep + 'return_url=' + encodeURIComponent(path);
  }

  var state = {
    ready: false,
    guest: false,
    items: [], // [{ productGid, variantId? }] — variantId GID biçiminde (backend'le aynı).
  };

  function buttons() {
    return document.querySelectorAll('[data-kremi-wish]');
  }

  // Ürün sayfasında ANA ürüne ait OLMAYAN alanlar (başka ürünlerin kartları / panelleri).
  var FOREIGN = 'product-card, .product-card, .horizontal-product-card, .promo-panel, product-recommendations, ' +
    '.complementary-products, .kremi-related-sets, cart-drawer, .kremi-story-viewer, .kremi-stories';

  /** Kartta/PDP'de o an SEÇİLİ varyantın GID'i (yoksa null). Mobil paritesi. */
  function currentVariantGid(btn) {
    var num = null;
    var card = btn.closest('.product-card, product-card, .horizontal-product-card');
    if (card) {
      // KART: seçili renk swatch'ı (radio) data-variant-id taşır — kartta form yok. Yatay kart
      // (<product-card class="horizontal-product-card">, kampanya paneli) da kart sayılır.
      var checked = card.querySelector('input[data-variant-id]:checked');
      if (checked) num = checked.getAttribute('data-variant-id');
    } else {
      // PDP: scope `.product-info`. AMA bu kapsamın İÇİNDE başka ürünlerin kartları da var:
      // kampanya paneli (promo-panel → <product-card class="horizontal-product-card">, ana
      // formdan ÖNCE), seçicideki ilgili set satırları (kremi-related-sets, kendi formlarıyla),
      // tamamlayıcı ürünler, story görüntüleyici. Eskiden yalnız ilk eşleşme
      // alınıyordu → 13 PDP'nin 11'inde kalp BAŞKA ürünün varyantını okuyor, favorideki ürün
      // boş kalp görünüyordu (10-05 ölçümü). Artık o kartların içindekiler tek tek elenir.
      var info = btn.closest('.product-info') || btn.closest('.shopify-section') || document;
      var mine = function (selector) {
        return Array.prototype.filter.call(info.querySelectorAll(selector), function (el) {
          return !el.closest(FOREIGN);
        });
      };
      // TEK-SEÇENEKLİ üründe (tek variant-picker option, ör. yalnız Renk): seçili swatch
      // radio'sunun data-variant-id'si SENKRON ve doğru — tıklamada checked ANINDA değişir.
      // Bunu ÖNCE oku: tema [name=id]'yi ancak variant render FETCH'i bitince günceller
      // (theme.js selectCombination async) → swatch'a basıp fetch bitmeden kalbe basılırsa
      // [name=id] ESKİ varyantı tutar ve yanlış varyant silinirdi (denetim 09-05 HIGH).
      if (mine('.variant-picker__option').length === 1) {
        var sw = mine('input[data-variant-id]:checked')[0];
        if (sw) num = sw.getAttribute('data-variant-id');
      }
      // Çok-seçenekli ürün: swatch tek varyantı temsil etmez → çözülmüş form id'si
      // tek doğru kaynak (fetch sonrası; o pencerede residual risk kabul, ürünler tek-seçenekli).
      if (!num) {
        var idInput = mine('[name="id"]').filter(function (el) { return el.value; })[0];
        if (idInput) num = idInput.value;
      }
    }
    if (!num) num = btn.getAttribute('data-variant-id-default');
    return num ? 'gid://shopify/ProductVariant/' + num : null;
  }

  /**
   * Verilen ürün+varyant için eşleşen kaydı bulur (backend sameEntry aynası):
   * önce TAM varyant eşleşmesi, yoksa ürün-düzeyi (variantId'siz eski/tek-varyant)
   * kayıt — o da o ürünün favorilendiğini gösterir.
   */
  function findEntry(productGid, variantGid) {
    var exact = null;
    var productLevel = null;
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      if (it.productGid !== productGid) continue;
      if (variantGid && it.variantId === variantGid) exact = exact || it;
      if (!it.variantId) productLevel = productLevel || it;
    }
    return exact || productLevel;
  }

  function paint(btn) {
    var on = !!findEntry(btn.dataset.gid, currentVariantGid(btn));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-active', on);
    var label = on ? btn.dataset.labelOn : btn.dataset.labelOff;
    if (label) btn.setAttribute('aria-label', label);
    var title = btn.querySelector('title');
    if (title) title.textContent = label || '';
  }

  function reveal() {
    state.ready = true;
    buttons().forEach(function (btn) {
      btn.hidden = false;
      paint(btn);
    });
  }

  function applyItems(items) {
    state.items = (items || []).filter(function (i) {
      return i && i.productGid;
    });
    buttons().forEach(paint);
    document.dispatchEvent(
      new CustomEvent('kremi:wishlist:changed', { detail: { items: items || [] } })
    );
  }

  function load() {
    // HIZ-HATA T5/H5/F7 (2026-10-01): misafir durumu Liquid'den zaten biliniyor
    // (window.KREMI_IS_GUEST, layout/theme.liquid customer==nil) — App Proxy'ye
    // 401 bekleyen bir istek atıp her sayfada konsol hatası üretmeye gerek yok.
    if (window.KREMI_IS_GUEST === true) {
      state.guest = true;
      reveal();
      return Promise.resolve(null);
    }

    return fetch(BASE, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 401) {
          // Beklenmedik durum (ör. KREMI_IS_GUEST enjekte edilmeden yüklenen sayfa):
          // proxy ÇALIŞIYOR, kullanıcı misafir → butonlar görünür, tık = giriş.
          state.guest = true;
          reveal();
          return null;
        }
        if (!res.ok) throw new Error('wishlist ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        reveal();
        applyItems(data.items);
      })
      .catch(function () {
        // App Proxy kurulu değil / ağ hatası → butonlar GİZLİ kalır.
      });
  }

  function toggle(btn) {
    if (state.guest) {
      window.location.href = loginUrlWithReturn(window.location.pathname);
      return;
    }
    var gid = btn.dataset.gid;
    if (!gid || btn.dataset.busy === '1') return;

    var variantGid = currentVariantGid(btn); // kartta/PDP'de SEÇİLİ varyant
    var entry = findEntry(gid, variantGid);
    var removing = !!entry;
    var snapshot = state.items.slice(); // hata olursa geri dönüş
    btn.dataset.busy = '1';

    var url;
    var body;
    if (removing) {
      // Kaldırma varyant-düzeyinde eşleştiyse o varyantı, ürün-düzeyi (eski) kayda
      // eşleştiyse tüm ürünü kaldır — backend removeItem aynı sözleşme.
      url = BASE + '/items/remove';
      body = entry.variantId ? { productGid: gid, variantId: entry.variantId } : { productGid: gid };
      state.items = state.items.filter(function (it) {
        return it !== entry;
      });
    } else {
      // Ekleme SEÇİLİ varyantla — mobil paritesi ("kart neyi gösteriyorsa o").
      url = BASE + '/items';
      body = { productGid: gid, handle: btn.dataset.handle || undefined };
      if (variantGid) body.variantId = variantGid;
      state.items.push({ productGid: gid, variantId: variantGid || undefined });
    }
    // İyimser geri bildirim: aynı ürünün TÜM kalpleri (kart+PDP) güncellenir.
    buttons().forEach(paint);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (res.status === 401) {
          state.guest = true;
          throw new Error('auth');
        }
        if (!res.ok) throw new Error('wishlist ' + res.status);
        return res.json();
      })
      .then(function (data) {
        applyItems(data.items);
      })
      .catch(function () {
        // Geri al — kullanıcıya yalan söyleme.
        state.items = snapshot;
        buttons().forEach(paint);
      })
      .finally(function () {
        btn.dataset.busy = '0';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kremi-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation(); // kart linkine tıklamış sayılmasın
    toggle(btn);
  });

  // Varyant değişince (kart swatch'ı) kalbi TAZELE: seçili varyant favorideyse dolu.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || t.type !== 'radio') return;
    if (!t.matches('input[data-variant-id], input[data-option-position]')) return;
    var host = t.closest('.product-card') || t.closest('.product-info') || t.closest('.shopify-section');
    if (!host) return;
    var hearts = host.querySelectorAll('[data-kremi-wish]');
    if (hearts.length) hearts.forEach(paint);
  });

  // PDP: tema variant:change YAYAR ve [name=id]'yi ONDAN ÖNCE günceller → bu olayda
  // yeniden boyamak zamanlama-güvenli (ham radio change'te id henüz eski olabilir).
  document.addEventListener('variant:change', function (e) {
    var host = (e.target && e.target.closest && e.target.closest('.product-info')) ||
      (e.target && e.target.closest && e.target.closest('.shopify-section'));
    var hearts = (host || document).querySelectorAll('[data-kremi-wish]');
    if (hearts.length) hearts.forEach(paint);
  });

  /**
   * Sonradan gelen kartlar (denetim 09-03, HIGH): tema filtre/sıralamada ızgara
   * DOM'unu TAZE sunucu HTML'iyle DEĞİŞTİRİYOR (theme.js facet:update →
   * replaceChildren). Yeni kartlar `hidden` doğduğu için kalpler kayboluyordu ve
   * tam sayfa yenilemesine kadar geri gelmiyordu. Olay dinlemek yetmez — tema
   * böyle bir olay yaymıyor; DOM'u kendimiz izliyoruz.
   */
  function rescan() {
    if (!state.ready) return;
    buttons().forEach(function (btn) {
      btn.hidden = false;
      paint(btn);
    });
  }

  var rescanQueued = false;
  function queueRescan() {
    if (rescanQueued) return;
    rescanQueued = true;
    // Tek turda çok sayıda düğüm eklenebilir; bir kez toparla.
    requestAnimationFrame(function () {
      rescanQueued = false;
      rescan();
    });
  }

  function watchDom() {
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-kremi-wish]')) return queueRescan();
          if (n.querySelector && n.querySelector('[data-kremi-wish]')) return queueRescan();
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Elle tetikleme yolu da kalsın (başka kod ızgarayı değiştirirse).
  document.addEventListener('kremi:wishlist:rescan', rescan);

  window.KremiWishlist = {
    load: load,
    isReady: function () {
      return state.ready;
    },
    isGuest: function () {
      return state.guest;
    },
    has: function (gid, variantGid) {
      return !!findEntry(gid, variantGid || null);
    },
  };

  function start() {
    watchDom();
    load();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
